import { render, staticRenderFns } from "./TwoMoreLines.vue?vue&type=template&id=45655c2c&scoped=true&"
import script from "./TwoMoreLines.vue?vue&type=script&lang=js&"
export * from "./TwoMoreLines.vue?vue&type=script&lang=js&"
import style0 from "./TwoMoreLines.vue?vue&type=style&index=0&id=45655c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45655c2c",
  null
  
)

export default component.exports